import { h } from 'preact'
import { memo } from 'preact/compat'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { getSymbol } from '../../helpers/common.js'
import {
  NORDIC_CURRENCIES,
  isSEKCurrency,
  isFinlandCulture,
  isEURCurrency,
  isNlCulture,
} from '../../constants/currencies'
import './styles.scss'

const PagePrice = ({
  amount = 0,
  currency = 'GBP',
  className = 'xlarge',
  culture,
}) => {
  const dividedNumber = Number(amount / 100)
    .toFixed(2)
    .toString()
    .split('.')
  const numberBeforeDot = dividedNumber[0]
  const numberAfterDot = dividedNumber[1] || '00'
  const symbol = getSymbol(currency, culture)

  const currencySymbol = (0)
    .toLocaleString(culture, {
      style: 'currency',
      currency,
      minimumFractionDigits: 0,
    })
    .replace('0', '')
    .trim()
  const classes = classNames('price', 'total', className)
  return (
    <span className={classes}>
      {!NORDIC_CURRENCIES.includes(currency) &&
        (!isFinlandCulture(culture) || !isEURCurrency(currency)) && (
          <abbr className="fraction" data-testid="currency-symbol">
            {currencySymbol} {isSEKCurrency(currency) && '\xA0'}
          </abbr>
        )}
      <var className="integer">{numberBeforeDot}</var>
      <span className="decimal">{isNlCulture(culture) ? ',' : '.'}</span>
      <var className="fraction">{numberAfterDot}</var>
      <var className="fraction">
        {'\xA0'}
        {symbol}
      </var>
    </span>
  )
}

PagePrice.propTypes = {
  amount: PropTypes.number,
  currency: PropTypes.string,
  className: PropTypes.string,
  culture: PropTypes.string,
}

export default memo(PagePrice)
